import { z } from 'zod';
export const SearchSchema = z.object({
  freeText: z.string().default(''),
  categoryIn: z.string().optional(),
  integratableOnly: z.boolean().default(false),
  outboundSsoOnly: z.boolean().default(false),
  page: z.number().default(1),
  pageSize: z.number().default(20)
});
export type SearchParams = z.infer<typeof SearchSchema>;